import { render, staticRenderFns } from "./UploadMultipleFiles.vue?vue&type=template&id=5c58ab16&scoped=true"
import script from "./UploadMultipleFiles.vue?vue&type=script&lang=js"
export * from "./UploadMultipleFiles.vue?vue&type=script&lang=js"
import style0 from "./UploadMultipleFiles.vue?vue&type=style&index=0&id=5c58ab16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c58ab16",
  null
  
)

export default component.exports